<template>
  <div>
    <v-bottom-sheet
      :content-class="['app-upload-tray', {'app-upload-tray--minimized': minimized}]"
      :model-value="!!store.items.length"
      :scrim="false"
      attach
      max-width="600"
      no-click-animation
      persistent
      scroll-strategy="none"
    >
      <v-card class="app-upload-tray__card">
        <v-card-title class="d-flex align-center">
          Upload In Progress
          <v-spacer />
          <v-icon @click="minimized = !minimized">
            {{ minimized ? 'mdi-plus' : 'mdi-minus' }}
          </v-icon>
        </v-card-title>
        <v-card-text class="app-upload-tray__card__body">
          <v-list>
            <v-list-item
              v-for="item in store.items"
              :key="item.id"
              lines="three"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ $file.formatFileSize(item.size) }}</v-list-item-subtitle>
              <div class="d-flex align-center ga-3">
                <v-progress-linear
                  :color="progressColor(item)"
                  :indeterminate="item.indeterminate"
                  :model-value="item.progress"
                  height="10"
                  rounded="lg"
                />
                {{ item.progress }}%
                <v-icon
                  v-if="item.status === 'error'"
                  @click="store.remove(item.id)"
                >
                  mdi-close
                </v-icon>
              </div>
              <v-messages
                :active="!!item.message"
                :color="item.status === 'error' ? 'error' : 'black'"
                :messages="[item.message!]"
                class="mb-1"
              />
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script lang="ts" setup>
import {onBeforeUnmount, onMounted, ref} from "vue"
import {type UploadItem, useUploadStore} from "@/stores/upload"

const store = useUploadStore()
const minimized = ref(false)

const progressColor = (item: UploadItem): string => {
  switch (item.status) {
    case "success":
      return "success"
    case "error":
      return "error"
    default:
      return "primary"
  }
}

const warnBeforeUnload = (event: BeforeUnloadEvent) => {
  if (!store.hasActive) {
    return
  }

  event.preventDefault()

  // Legacy browsers only show the prompt when returnValue is set
  event.returnValue = ""
}

onMounted(() => {
  window.addEventListener("beforeunload", warnBeforeUnload)
})

onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", warnBeforeUnload)
})
</script>

<style lang="scss" scoped>
@use "@/scss/settings";
@use "sass:map";

:deep(.app-upload-tray) {
  position: fixed !important;
  bottom: 0;
  left: unset !important;

  box-shadow: unset !important;
  transition: transform 0.3s ease-in-out !important;
  transform: translateY(0) !important;

  @media #{map.get(settings.$display-breakpoints, 'md-and-up')} {
    right: 16px !important;
  }
}

:deep(.app-upload-tray--minimized) {
  transform: translateY(calc(100% - 45px)) !important;
}

.app-upload-tray__card {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;

  &__body {
    max-height: 400px;
    overflow-y: auto;
  }
}
</style>
